import { generalIconsList } from 'react-scale/components/elements/general-icons';

import * as ThreeDCuboidExample from './3d-sensor-fusion/cuboid';
import * as ThreeDSegmentation from './3d-sensor-fusion/segmentation';
import * as ImageBoundingBoxExample from './image/bounding-box';
import * as ImageClassificationExample from './image/classification';
import * as ImageCuboidExample from './image/cuboid';
import * as ImageLinesSplinesExample from './image/lines-splines';
import * as ImagePointExample from './image/point';
import * as ImagePolygonExample from './image/polygon';
import * as ImageSemanticSegmentationExample from './image/semantic-segmentation';
import * as ImageTranscriptionExample from './image/transcription';
import * as CatalogAttributeEnrichment from './catalog/attribute-enrichment';
import * as CatalogGeneration from './catalog/generation';
import * as TextNERExample from './text/ner';
import * as TextClassificationExample from './text/classification';
import * as TextMLDataCollection from './text/ml-data-collection';
import * as DocumentMLTranscription from './document/ml-transcription';
// import * as DocumentClassification from './document/classification';
// import * as DocumentDataExtraction from './document/data-extraction';
import * as DocumentDataExtractionLogistics from './document/data-extraction-logistics';
import * as DocumentDataExtractionHealthcare from './document/data-extraction-healthcare';
import * as DocumentDataExtractionFinancial from './document/data-extraction-financial';
import * as VideoBoundingBox from './video/bounding-box';
import * as VideoClassification from './video/classification';
import * as VideoPolygon from './video/polygon';
import * as VideoCuboid from './video/cuboid';
import * as LaunchBoundingBoxExample from './launch/launch-bounding-box';

export const annotationTypes = {
  threeDSensorFusion: [
    {
      label: 'Cuboid',
      icon: 'cuboid',
      example: ThreeDCuboidExample
    },
    {
      label: 'Segmentation',
      icon: 'segmentation',
      example: ThreeDSegmentation
    }
  ],
  image: [
    {
      label: 'Bounding Box',
      icon: 'boundingBox',
      example: ImageBoundingBoxExample
    },
    {
      label: 'Classification',
      icon: 'classification',
      example: ImageClassificationExample,
      responseDelay: 2
    },
    {
      label: 'Cuboid',
      icon: 'cuboid',
      example: ImageCuboidExample
    },
    {
      label: 'Lines & Splines',
      icon: 'linesSplines',
      example: ImageLinesSplinesExample
    },
    {
      label: 'Point',
      icon: 'point',
      example: ImagePointExample
    },
    {
      label: 'Polygon',
      icon: 'polygon',
      example: ImagePolygonExample
    },
    {
      label: 'Segmentation',
      icon: 'segmentation',
      example: ImageSemanticSegmentationExample
    },
    {
      label: 'Transcription',
      icon: 'transcription',
      example: ImageTranscriptionExample
    }
  ],
  catalog: [
    {
      label: 'Generation',
      icon: 'catalog',
      example: CatalogGeneration
    },
    {
      label: 'Attribute Enrichment',
      icon: 'catalog',
      example: CatalogAttributeEnrichment
    }
  ],
  text: [
    {
      label: 'Named Entity Recognition',
      icon: 'ner',
      example: TextNERExample,
      responseDelay: 1
    },
    {
      label: 'Classification',
      icon: 'classification',
      example: TextClassificationExample,
      responseDelay: 2
    },
    {
      label: 'Multi-lingual Transcription',
      icon: 'transcription',
      example: DocumentMLTranscription,
      responseDelay: 2
    },
    {
      label: 'Multi-lingual Data Collection',
      icon: 'collection',
      example: TextMLDataCollection,
      responseDelay: 3
    }
  ],
  document: [
    {
      label: 'Logistics',
      icon: 'logistics',
      example: DocumentDataExtractionLogistics,
      responseDelay: 2,
      video: {
        src: 'https://scaleai.wistia.com/medias/0zcdnvj8ht',
        poster: '/static/images/pages/document/covers/industries/logistics.png'
      },
      blurb: {
        title: 'Bills of Lading, Commercial Invoices, Packing Lists, and more',
        subtitle:
          'Reduce delays when clearing customs and delivering goods, minimize operational costs, and get paid on time. Document AI is template-free, fast, and extracts data from your documents at human-level accuracy.',
        icon: generalIconsList.logisticsBox
      }
    },
    {
      label: 'Financial Services',
      icon: 'financialServices',
      example: DocumentDataExtractionFinancial,
      responseDelay: 2,
      video: {
        src: 'https://scaleai.wistia.com/medias/5p34uli2b0',
        poster: '/static/images/pages/document/covers/industries/financial.png'
      },
      blurb: {
        title: 'Invoices, Mortgage Applications, Tax Documents, IDs, and more',
        subtitle:
          'Move to real-time when servicing your customers without sacrificing accuracy. With Document AI, underwriters become more efficient and accounting can issue expenses faster. Optional human-in-the-loop QA is available.',
        icon: generalIconsList.financialServicesCard
      }
    },
    {
      label: 'Healthcare',
      icon: 'healthcare',
      example: DocumentDataExtractionHealthcare,
      responseDelay: 2,
      video: {
        src: 'https://scaleai.wistia.com/medias/5cwu8s4zpg',
        poster: '/static/images/pages/document/covers/industries/healthcare.png'
      },
      blurb: {
        title: 'Claims Forms, Medical Records, IDs, Insurance Cards, and more',
        subtitle:
          'Move to real-time when servicing your customers without sacrificing accuracy With Document AI, healthcare organizations make faster critical decisions. Our solution processes complex medical documents at high quality and instant turnarounds times.',
        icon: generalIconsList.healthInsuranceCard
      }
    }
  ],
  video: [
    {
      label: 'Bounding Box',
      icon: 'boundingBox',
      example: VideoBoundingBox,
      responseDelay: 1
    },
    {
      label: 'Classification',
      icon: 'classification',
      example: VideoClassification,
      responseDelay: 1
    },
    {
      label: 'Polygon',
      icon: 'polygon',
      example: VideoPolygon,
      responseDelay: 1
    },
    {
      label: 'Cuboid',
      icon: 'cuboid',
      example: VideoCuboid,
      responseDelay: 1
    }
  ],
  mapping: [
    {
      label: 'Vector Annotations',
      image: '/static/img/website/mapping/hiw/vector-maps.svg'
    },
    {
      label: 'Semantic Annotations',
      image: '/static/img/website/mapping/hiw/semantic-maps.svg'
    },
    {
      label: 'Semantic Linking',
      image: '/static/img/website/mapping/hiw/semantic-linking.svg'
    }
  ],
  launch: [
    {
      label: 'Launch Bounding Box',
      icon: 'boundingBox',
      example: LaunchBoundingBoxExample
    }
  ]
};

export const productTypes = [
  {
    label: 'Scale 3D Sensor Fusion',
    icon: 'threeD',
    content: annotationTypes.threeDSensorFusion,
    landingHref: '/3d-sensor-fusion'
  },
  {
    label: 'Scale Text',
    icon: 'text',
    content: annotationTypes.text,
    landingHref: '/text'
  },
  {
    label: 'Scale Image',
    icon: 'image',
    content: annotationTypes.image,
    landingHref: '/image'
  },
  {
    label: 'Scale Video',
    icon: 'video',
    content: annotationTypes.video,
    landingHref: '/video'
  },
  {
    label: 'Scale Mapping',
    icon: 'mapping',
    content: annotationTypes.mapping,
    landingHref: '/mapping'
  }
];

export default annotationTypes;
